import { Grid, TextField } from "@mui/material";
import React from "react";

const AddEditPatientTextArea = ({
  label,
  metadata,
  handleMetadataChange,
  inputFieldSyle,
}) => {
  return (
    <Grid xs={12} item>
      <TextField
        label={label}
        rows={2}
        className="add-edit-patient-textarea"
        multiline
        name={label}
        value={metadata?.[label]}
        onChange={handleMetadataChange}
        InputLabelProps={{
          shrink: metadata?.[label],
        }}
        sx={inputFieldSyle}
      />
    </Grid>
  );
};

export default AddEditPatientTextArea;
